<!-- 会员首页 -->
<template>
  <div class="ucenter">
    <el-row :gutter="20">
      <!-- 左侧导航栏 -->
      <el-col :span="5" class="ucenter-sider">
        <div class="sidebar-container">
          <div class="sidebar-title">会员中心</div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <div class="collapse-item__title">
                  <i class="el-icon-shopping-cart-2" style="margin-right: 8px; color: #ff6b6b;"></i>
                  交易中心
                </div>
              </template>
              <ul class="collapse-item__ul">
                <li v-for="(item, k) in tradeMenu" :key="k" @click="changeUrl(item)"
                  :class="{ 'active': item.id === activeId }">
                  {{ item.title }}
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="19" class="ucenter-content">
        <div class="content-container">
          <!-- VIP用户信息卡 -->
          <div class="vip-card">
            <div class="vip-header">
              <div class="vip-badge">
                <img :src="require('@/assets/imgs/ucenter/vip.png')" alt="VIP" />
                <!-- <span class="vip-level">1</span> -->
              </div>
              <div class="user-info">
                <div class="username">您好，{{ user ? user.username : "" }}</div>
                <div class="user-stats">
                  <div class="stat-item">
                    <span class="stat-label">当前拿货</span>
                    <span class="stat-value">{{ order_num }}单</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">保级/升级</span>
                    <span class="stat-value">0单/0单</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="progress-section">
              <div class="progress-info">
                <span>进度</span>
                <span class="progress-percent">0%</span>
              </div>
              <el-progress :text-inside="true" :stroke-width="12" :percentage="0" color="#ff6b6b"></el-progress>
              <div class="level-up-info">
                再拿货0单，您下个结算周期升级为VIP1
              </div>
            </div>
          </div>

          <!-- 订单统计区域 -->
          <div class="stats-section">
            <div class="order-stats">
              <div class="stats-row">
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="el-icon-document"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">等待付款</div>
                    <div class="stat-value">{{ wait_pay_num }}</div>
                  </div>
                </div>

                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="el-icon-truck"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">等待发货</div>
                    <div class="stat-value">{{ wait_express_num }}</div>
                  </div>
                </div>

                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="el-icon-refresh"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">退换货</div>
                    <div class="stat-value">{{ refund_num }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 金币和退货地址合并区域 -->
          <div class="balance-return-section">
            <div class="balance-card">
              <div class="balance-item">
                <div class="balance-label">金币</div>
                <div class="balance-value">￥{{ gold_total }}</div>
              </div>
              <div class="balance-item">
                <div class="balance-label">优惠券</div>
                <div class="balance-value">0</div>
              </div>
              <div class="action-buttons-inline">
                <el-button size="medium" type="danger" @click="charge" class="action-btn">
                  金币充值
                </el-button>
                <el-button size="medium" type="primary" @click="payBack" class="action-btn">
                  金币提现
                </el-button>
                <router-link :to="'/gold'" target="_blank">
                  <el-button size="medium" type="info" class="action-btn">
                    金币明细
                  </el-button>
                </router-link>
              </div>
            </div>
          
            <div class="return-address-card">
              <div class="address-item">
                <span class="address-label">地址：</span>
                <span class="address-value">江苏省扬州市邗江区朱塘路110号普创电子二楼右门</span>
              </div>
              <div class="address-item">
                <span class="address-label">联系人：</span>
                <span class="address-value">退货组</span>
              </div>
              <div class="address-item">
                <span class="address-label">联系电话：</span>
                <span class="address-value">15861388608</span>
              </div>
              <div class="address-item">
                <el-button size="large" type="primary" @click="copyAddress">复制</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 充值弹窗 -->
    <el-dialog title="金币充值" width="600px" :visible.sync="chargeDialogVisible" class="charge-dialog">
      <el-form :model="form">
        <el-form-item label="充值金额" label-width="120">
          <el-input-number v-model.trim="form.money" placeholder="请输入充值金额" :min="0.01"
            style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label-width="120">
          <el-alert :closable="false" title="提示" type="error" description=" 1.充值(支付)金额仅用于产品零差价代拿货(发货)，产品知识产权纠纷自行负责，或联系产品供货商家辨别，与绒博汇平台无关。
            2.为防止恶意下单，已充值或下单产生的退货退款将以同等值金币返还到用户账户，金币在本平台可用于支付产品、代发、快递费用。如需退现金应支付1%的手续费（此手续费在支付宝支付成功后已形成）。" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chargeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doCharge">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUcenterCollapseItems } from "@/util/common";

export default {
  name: "Index",
  data() {
    return {
      activeName: "1",
      activeId: 0,
      tradeMenu: [],
      chargeDialogVisible: false,
      loading: false,
      user: null,
      gold_total: 0,
      order_num: 0,
      wait_pay_num: 0,
      wait_express_num: 0,
      refund_num: 0,
      form: {
        money: "",
      },
    };
  },
  created() {
    this.tradeMenu = getUcenterCollapseItems();
    this.user = this.$store.getters.getUser;
    this.getData();
  },
  mounted() { },
  methods: {
    /**
     *
     */
    async getData() {
      const { data } = await this.$axios.get(
        this.$newApi + "/api/rbh/user/gold?uid=" + this.user.id
      );
      if (data.code === 200) {
        this.gold_total = data.data.gold;
        this.order_num = data.data.order_num;
        this.wait_pay_num = data.data.wait_pay_num;
        this.wait_express_num = data.data.wait_express_num;
        this.refund_num = data.data.refund_num;
      }
    },
    /**
     * 充值
     */
    charge() {
      this.chargeDialogVisible = true;
    },
    /**
     * 提现
     */
    payBack() {
      this.notifySucceed("提现功能开发中，请先联系客服提现!");
    },
    /**
     * 充值金币发起支付
     */
    doCharge() {
      if (this.user.id <= 0) {
        this.notifyError("请重新登录!");
        return false;
      }
      if (parseFloat(this.form.money) <= 0) {
        this.notifyError("请确认充值金额大于0!");
        return false;
      }
      window.location.href =
        "https://apicenter.toysmodel.cn/api/63d92bcce7f58?uid=" +
        this.user.id +
        "&money=" +
        this.form.money;
    },
    /**
     * 切换链接
     * @param {*} item
     */
    changeUrl(item) {
      if (item.url) {
        this.activeId = item.id;
        this.$router.push(item.url);
      }
    },
    /**
     * 复制地址
     */
    copyAddress() {
      const address = "江苏省扬州市邗江区朱塘路110号普创电子二楼右门";
      const el = document.createElement('textarea');
      el.value = address;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$message.success('地址已复制');
    }
  },
};
</script>

<style scoped>
.ucenter {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 20px 0;
}

.ucenter .ucenter-sider {
  padding-right: 10px;
}

.sidebar-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ff6b6b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-collapse {
  border: none;
}

.collapse-item__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.collapse-item__ul {
  padding: 10px 0 0 0;
}

.collapse-item__ul li {
  color: #757578;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  padding-left: 1em;
  cursor: pointer;
  border-radius: 6px;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.collapse-item__ul li:hover {
  background-color: #f8f9fa;
  color: #ff6b6b;
  padding-left: 1.5em;
}

.collapse-item__ul .active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white !important;
  padding-left: 1.5em;
}

.ucenter .ucenter-content {
  padding-left: 10px;
}

.content-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

/* VIP用户信息卡 */
.vip-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
  color: white;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.vip-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.vip-badge {
  position: relative;
}

.vip-badge img {
  width: 80px;
  height: 100px;
}

.vip-level {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
}

.user-info {
  flex: 1;
}

.username {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.user-stats {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
}

.stat-label {
  opacity: 0.9;
}

.stat-value {
  font-weight: 600;
}

.progress-section {
  margin-top: 15px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.progress-percent {
  font-weight: 600;
}

.level-up-info {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  opacity: 0.9;
}

/* 统计和操作区域 */
.stats-section {
  display: flex;
  gap: 20px;
}

.order-stats {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
}

.stats-row {
  display: flex;
  gap: 15px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  flex: 1;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #ff6b6b;
}

.combined-section {
  display: flex;
  gap: 20px;
  width: 100%;
}

.balance-return-section {
  display: flex;
  gap: 20px;
  width: 100%;
}

.balance-card {
  flex: 1;
  min-width: 300px;
  background: white;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.balance-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.balance-item:last-child {
  border-bottom: none;
}

.balance-label {
  color: #999;
}

.balance-value {
  font-weight: 600;
  color: #ff6b6b;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.action-buttons-inline {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.action-btn {
  border-radius: 6px;
  font-weight: 500;
}

.action-buttons-inline .action-btn {
  flex: 1;
}

.action-btn.el-button--danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  border: none;
}

.action-btn.el-button--primary {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  border: none;
}

.action-btn.el-button--info {
  background: linear-gradient(135deg, #909399 0%, #606266 100%);
  border: none;
}

.return-address-card {
  flex: 2;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  margin-top: 0;
}

.cs-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.cs-content {
  display: flex;
  justify-content: center;
}

.cs-qrcode {
  width: 150px;
  height: 150px;
  border-radius: 12px;
  border: 1px solid #eee;
}

.address-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.address-item:last-child {
  margin-bottom: 0;
}

.address-label {
  font-weight: 600;
  color: #333;
  width: 80px;
}

.address-value {
  color: #ff6b6b;
  flex: 1;
}

/* 充值弹窗样式 */
.charge-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.charge-dialog .el-dialog__header {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  padding: 15px 20px;
}

.charge-dialog .el-dialog__title {
  color: white;
}

.charge-dialog .el-dialog__body {
  padding: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>